import { z } from "zod";
import { ADDRESS, ALTERNATE_LOGIN_ID, EMAIL_ID_1, FIRST_NAME, LAST_NAME, MOBILE_NO, USER_ID,
  ADDRESS_1,
  ADDRESS_2,
  CITY,
  EMAIL_ID_2,
  END_DATE,
  LANDLINE_NO,
  OCCUPANCY_TYPE,
  PO_BOX,
  START_DATE,
  STATE,
  USERNAME,
  ZIPCODE,
  USER_TYPE,
  OWNERSHIP_SHARE,
  ROW_INDEX,
 } from "../consts";

export const schema = z.object({
  [ROW_INDEX]: z.string().optional(),
  [USER_TYPE]: z.string().optional(),
  [USER_ID]: z.string().optional(),
  [OWNERSHIP_SHARE]: z.string().optional(),
  [ALTERNATE_LOGIN_ID]: z.string().min(4, "This Field is required"),
  [FIRST_NAME]: z.string().min(2, "This Field is required"),
  [LAST_NAME]: z.string().min(2, "This Field is required"),
  [MOBILE_NO]: z.string().min(10, "This Field is required"),
  [EMAIL_ID_1]:   z
    .string()
    .email("This is not a valid email.")
    .optional()
    .or(z.literal("")),
  [ADDRESS]: z.object({
    [ADDRESS_1]: z.string().min(1, "This Field is required"),
    [ADDRESS_2]: z.string().optional(),
    [ZIPCODE]: z
      .string()
      .min(1, "This Field is required")
      .regex(
        /^[0-9]{5}-[0-9]{4}$/,
        "Enter ZIP code in XXXXX-XXXX format."
      ),
    [STATE]: z.string().min(1, "This Field is required"),
    [CITY]: z.string().min(1, "This Field is required"),
    [PO_BOX]: z.string().min(1, "This Field is required"),
  }),
  [OCCUPANCY_TYPE]: z.string().min(1, "This Field is required"),

  // Optional Fields
  [LANDLINE_NO]: z.string().optional(),
  [EMAIL_ID_2]: z
    .string()
    .email("This is not a valid email.")
    .optional()
    .or(z.literal("")),

  [START_DATE]: z
    .union([z.string(), z.date()])
    .refine((val) => !isNaN(Date.parse(val.toString())), {
      message: "Invalid date format.",
    }),
  [END_DATE]: z
    .union([z.string(), z.date()])
    .refine((val) => !val || !isNaN(Date.parse(val.toString())), {
      message: "Invalid date format.",
    })
    .optional(),
  [USERNAME]: z.string().min(4, "This Field is required"),
});

export type formValues = z.infer<typeof schema>;
